const streams = ["Science", "Commerce", "Arts"];
export default streams;
